import React, { useContext, useState } from "react";
import { Divider, Flex, Button, DatePicker, Space, InputNumber } from "antd";
import { PaymentLinkContext } from "../../../context/PaymentLinkContext";
import { mainFilterPaymentLink, buttonStatusFilter, filterPaymentLink } from "../utils/script/indexUtils";
import '../utils/index.css';

const FilterPart = ({ showFilterModal, setFilteredLinks }) => {
    // Context variables
    const { paymentLinks, setPaymentLinks } = useContext(PaymentLinkContext);

    // Loacal state variables
    const [minAmount, setMinAmount] = useState(null);
    const [maxAmount, setMaxAmount] = useState(null);
    const [status, setStatus] = useState("ALL");
    const [date, setDate] = useState(null);

    const onChange = (date, dateString) => {
        console.log(date, dateString);
    };

    const doFilter = (data, status, minAmount, maxAmount) => {
        setFilteredLinks(filterPaymentLink(data, status, minAmount, maxAmount));
        showFilterModal(false);
    }

    return (
        <div>
            <div className="status-part-filter-modal">
                <Divider orientation="left" plain>
                    Statut
                </Divider>
                <Flex gap="small" wrap>
                    {buttonStatusFilter.map((btn) => (
                        <Button
                            key={btn.value}
                            color="default"
                            variant="outlined"
                            size="small"
                            onClick={() => setStatus(btn.value)}
                            style={{
                                fontSize: '12px',
                                backgroundColor: status === btn.value ? '#3761FF14' : 'transparent',
                                borderColor: status === btn.value ? '#3761FF' : undefined,
                                color: status === btn.value ? '#3761FF' : undefined,
                            }}
                        >
                            {btn.label}
                        </Button>
                    ))}
                </Flex>
            </div>
            <div>
                <Divider orientation="left" plain>
                    Date
                </Divider>
                <DatePicker onChange={onChange} size="small" placeholder="Selectionner une date" />
            </div>
            <div>
                <Divider orientation="left" plain>
                    Montant
                </Divider>
                <Space>
                    <InputNumber
                        placeholder="Min"
                        min={0}
                        prefix="FCFA"
                        style={{ width: 120, fontSize: '12px' }}
                        size="small"
                        value={minAmount}
                        onChange={(value) => setMinAmount(value)}
                    />
                    <span>-</span>
                    <InputNumber
                        placeholder="Max"
                        min={0}
                        prefix="FCFA"
                        style={{ width: 120, fontSize: '12px' }}
                        size="small"
                        value={maxAmount}
                        onChange={(value) => setMaxAmount(value)}
                    />
                </Space>
            </div>
            <Button key="submit" type="primary" className="mt-3 w-100 m-auto" size="small" onClick={() => doFilter(paymentLinks, status, minAmount, maxAmount)}>
                Appliquer le filtre
            </Button>
        </div>
    )
}

export default FilterPart;